<div class="content">
  <div class="tradeskills">
    <div></div>
  </div>
  <div class="title">World of Warcraft - Tradeskills</div>
  <div class="menu">
    <a  routerLink="index.html" [queryParams]="{version: 'classic'}"><div class="classic"></div></a>
    <a routerLink="index.html" [queryParams]="{version: 'tbc'}"><div class="tbc"></div></a>
    <a routerLink="index.html" [queryParams]="{version: 'wotlk'}"><div class="wotlk"></div></a>
  </div>
</div>
